import { render, staticRenderFns } from "./ReportItems.vue?vue&type=template&id=70787c5c&scoped=true"
import script from "./ReportItems.vue?vue&type=script&lang=js"
export * from "./ReportItems.vue?vue&type=script&lang=js"
import style0 from "./ReportItems.vue?vue&type=style&index=0&id=70787c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70787c5c",
  null
  
)

export default component.exports